<template>
  <div class="basket">
    <div class="pad-single">
      <p class="title is-4 is-font-regular u-no-wrap">Quote basket</p>
      <p class="subtitle is-6 text-brand-primary-600">
        Get an instant quote on up to five printers at a time.
      </p>
      <ul
        v-if="basketCount > 0"
        class="u-no-wrap block"
      >
        <li
          v-for="(item, i) in basket"
          :key="i"
          class="basket-item"
        >
          <div class="level is-mobile">
            <div class="level-left">
              <div class="level-item">
                <div class="is-block">
                  <strong class="is-block">{{ item.model }}</strong>
                  <span class="is-block">{{ item.brand }}</span>
                </div>
              </div>
            </div>
            <div class="level-right">
              <span class="level-item">
                <span
                  class="icon match-line"
                  @click="remove(item.modelId)"
                >
                  <Icon :icon="faCircleMinus" />
                </span>
              </span>
            </div>
          </div>
        </li>
      </ul>
      <div class="field has-addons">
        <button
          class="button is-action is-outlined is-fullwidth quote-all-printers-button rounded-md py-3 transition-all duration-300"
          :disabled="!basketCount > 0"
          @click="quoteComparison"
        >
          <Icon
            :icon="faBolt"
            class="mr-1"
          />
          <span>Instant quote</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
// Store actions
import { ref, computed } from 'vue'
import { logger } from '@repo/helpers/util/logger.js'
import { storeToRefs } from 'pinia'
import { useBasketStore } from '@/store/modules/basket.ts'
import { useModal } from '@/composables/useModal.js'
import { Icon } from '@repo/ui'
import { faBolt } from '@repo/icons/light/faBolt'
import { faCircleMinus } from '@repo/icons/light/faCircleMinus'

const modal = useModal()
const basketStore = useBasketStore()
const { basket, basketCount } = storeToRefs(basketStore)
const { closeBasket, clearBasket, openBasket, removeFromBasket } = basketStore
function remove(id) {
  removeFromBasket(id)
}

function quoteComparison() {
  // TODO: Add modal
  logger.log('Opening quote comparison modal')
  modal.switchModal('QuoteDetails')
  closeBasket()
}

function clearBasketCloseMenu() {
  clearBasket()
  closeBasket()
}
// methods: {
//   // openBasket () {
//   //   this.toggleBasketOpen()
//   // },
//   ...mapActions(['closeBasket', 'openModal', 'clearBasket', 'openBasket', 'removeFromBasket']),
//   remove(id) {
//     this.removeFromBasket(id)
//   },
//   quoteComparison() {
//     this.openModal('QuoteDetails')
//     this.closeBasket()
//   },
//   clearBasketCloseMenu() {
//     this.clearBasket()
//     this.closeBasket()
//   },
//   closeNav() {
//     // Closes if slide nav if it is open
//     if (this.deviceNavOpen) {
//       this.$emit('toggle-nav')
//     }
//   },
// },
// }
</script>
